
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/footerItems/contactUs",
      function () {
        return require("private-next-pages/footerItems/contactUs/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/footerItems/contactUs"])
      });
    }
  